import { css } from '@moneko/css';
export const styles = css`
  :host {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 16px;
    pointer-events: none;
  }

  .notification {
    inline-size: fit-content;
    display: flex;
    align-items: center;
    border-radius: var(--border-radius);
    padding: 5px 16px;
    background-color: var(--modal-component-bg);
    opacity: var(--opacity);
    box-shadow: var(--notification-box-shadow);
    backdrop-filter: blur(10px);
    gap: 8px;
    pointer-events: all;
    animation: scale-in 0.2s forwards;

    &.closeing {
      animation: scale-out 0.2s forwards;
    }

    &.error {
      color: var(--error-color);
      background-color: var(--error-notify-bg);
    }

    &.success {
      color: var(--success-color);
      background-color: var(--success-notify-bg);
    }

    &.warning {
      color: var(--warning-color);
      background-color: var(--warning-notify-bg);
    }

    &.primary {
      color: var(--primary-color);
      background-color: var(--primary-notify-bg);
    }
  }

  .close {
    border-radius: 16px;
    font-size: 14px;
    text-align: center;
    opacity: 0.8;
    outline: 2px solid transparent;
    transition: transform var(--transition-duration);
    transform: translate3d(50%, 0, 1px);
    cursor: pointer;
    block-size: 14px;
    line-height: 1;
    inline-size: 14px;

    &::before {
      content: '⛌';
    }

    &:hover {
      opacity: 1;
    }
  }

  @keyframes scale-in {
    from {
      transform: translate3d(0, -100%, 1px);
      opacity: 0;
    }

    to {
      transform: translate3d(0, 0, 1px);
      opacity: 1;
    }
  }

  @keyframes scale-out {
    0% {
      z-index: -1;
      opacity: 1;
      margin-block-start: 0;
    }

    100% {
      z-index: -1;
      opacity: 0;
      margin-block-start: -50px;
    }
  }
`;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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